import axios, { AxiosRequestConfig, AxiosResponse, Method } from "axios";
import { v4 } from "uuid";

import { getAuthToken } from "../utils";

console.log(`BASE URL`, import.meta.env.VITE_BASE_URL);

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

apiClient.interceptors.request.use(function (config) {
  const token = getAuthToken();
  if (config.headers === undefined) {
    // @ts-ignore
    config.headers = {};
  }

  if (token) {
    config.headers.Authorization = token;
  }

  config.headers["x-ig-trace-id"] = v4();

  return config;
});

export const _request = async <Response, Data>(
  method: Method,
  url: string,
  config?: AxiosRequestConfig
) =>
  apiClient.request<Response, AxiosResponse<Response>, Data>({
    method,
    url,
    ...config,
  });

export const api = {
  get: async <Response, Data = any>(url: string, config?: AxiosRequestConfig) =>
    _request<Response, Data>("GET", url, { ...config }),
  post: async <Response, Data = any>(
    url: string,
    data: Data,
    config?: AxiosRequestConfig
  ) => _request<Response, Data>("POST", url, { data, ...config }),
  put: async <Response, Data = any>(
    url: string,
    data: Data,
    config?: AxiosRequestConfig
  ) => _request<Response, Data>("PUT", url, { data, ...config }),
  patch: async <Response, Data = any>(
    url: string,
    data: Data,
    config?: AxiosRequestConfig
  ) => _request<Response, Data>("PATCH", url, { data, ...config }),
  delete: async <Response, Data = any>(
    url: string,
    config?: AxiosRequestConfig
  ) => _request<Response, Data>("DELETE", url, { ...config }),
};
